import { Action } from '@ngrx/store';
import { LoadHolidaysRequest } from '@cemex-core/cmx-api';

export enum LoadHolidaysActionTypes {
  LOAD = '[LoadHolidays] Load Holidays',
  LOAD_COMPLETE = '[LoadHolidays] Complete Load Holidays',
}

export class LoadHolidaysAction implements Action {
  readonly type = LoadHolidaysActionTypes.LOAD;

  constructor(public payload: LoadHolidaysRequest) {}
}

export class LoadHolidaysCompleteAction implements Action {
  readonly type = LoadHolidaysActionTypes.LOAD_COMPLETE;

  constructor(public payload: Date[]) {}
}

export type LoadHolidaysActions = LoadHolidaysAction | LoadHolidaysCompleteAction;
